import React, { useState, useEffect } from 'react';
import { LogicalFields } from './LogicalFields';

export const Filter = (props) => {
  const [ isDisabled, setIsDisabled ] = useState(true);
  const [ selectData, setSelectData ] = useState([]);
  const [ filtersAmount, setFiltersAmount ] = useState([{filter_index: 0, filter_key: Math.round(Math.random() * 1000000), filter_condition: ""}]);

  useEffect(() => {
    props.filters.map(filter => {
      let obj = {
        label: filter.name,
        value: filter.key
      }

      setSelectData(selectData => [...selectData, obj]);
    });

  }, []);

  const handleChange = () => {
    const { data, setData } = props.parentData;
    setData({...data, filter: []});
    setIsDisabled(!isDisabled);
  }

  const handleClick = ({target}) => {
    let condition = target.getAttribute('data-condition');
    let filter = target.getAttribute('data-filter');
    let arr = filtersAmount;

    if ( condition === "remove" && arr[filter] ) {
      let arr = filtersAmount;
      if ( !arr[filter] ) return;

      arr.splice(filter);
      target.parentNode.parentNode.querySelectorAll('.conditions__wrapper')[filter-1].querySelector('.titled__buttons').style.display = "initial"
      target.parentNode.remove();
      return setFiltersAmount(arr);
    }

    if ( arr.length === 2 ) return;

    target.parentNode.style.display = "none";
    setFiltersAmount(filtersAmount => [...arr, {
      filter_index: arr.length === 1 ? 1 : arr.length++,
      filter_key: Math.round(Math.random() * 1000000),
      filter_condition: condition
    }]);
  }

  return (
    <div className="block block__filter">
      <div className="block__body">
        <p className="title"><i className="linearicons-funnel"></i> Filtro</p>

        <div className="switch__group">
          <label htmlFor="disableFilter">Habilitar filtros?</label>
          <input type="checkbox" id="disableFilter" name="disableFilters" onChange={handleChange} checked={!isDisabled} />
          <span className="toggle" htmlFor="disableFilter" data-content={isDisabled ? "NÃO" : "SIM"} onClick={handleChange}></span>
        </div>

        {
          !isDisabled ?
            filtersAmount && filtersAmount.length !== 0 ?
              filtersAmount.map(filter => {
                return <LogicalFields key={filter.filter_key} index={filter.filter_index} condition={filter.filter_condition} selectData={selectData} domain={props.domain} handleClick={handleClick} parentState={props.parentData}/>
              })
            : null
          : null
        }
      </div>
    </div>
  )
}